import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `{{ score }} ({{ grade }})`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RankGradeComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  score: string;
  grade: string;

  ngOnInit(): void {
    this.score = this.data[this.key];
    this.grade = this.data[this.key.replace('Score', 'Grade')];
  }
}
